import React from "react";
import { SettingRow } from "../SettingRow";
import { Text } from "../../../../../../common/components/input/Text";
import { Adornment } from "../../../../input/Adornment";

interface ConsentBannerPreviewURLRowProps {
  formApi: {
    change: (field: string, value: string) => void;
    getFieldState: (name: string) => undefined | { value: string };
  };
}

export const ConsentBannerPreviewURLRow = (_props: ConsentBannerPreviewURLRowProps) => {
  return (
    <SettingRow
      maxWidthChildren={true}
      title="Preview URL"
      helpText={"The page on your website you'd like to see with your banner preview."}
    >
      <div>
        <Text
          className="w-100 mb-sm"
          fullWidth={false}
          field="previewURL"
          title="Preview URL"
          placeholder="www.example.com"
          label="Preview URL"
          variant="outlined"
          required
          InputProps={{
            startAdornment: <Adornment position="start">https://</Adornment>,
          }}
          onChange={(event) => {
            if (!event.target.value) {
              return;
            }

            // Remove http:// or https:// from the beginning of the URL if present
            const cleanedValue = event.target.value.replace(/^https?:\/\//i, "");
            _props.formApi.change("previewURL", cleanedValue);
          }}
        />
      </div>
    </SettingRow>
  );
};
